import React, { useState, useEffect } from 'react';
import { InputSelect } from '@/components/ui/inputs/input-select';
import { Input } from '@/components/ui/inputs/input';
import POSSidebarTable from './POSSidebarTable';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';
import { cn } from '@/lib/utils';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { setTableSideDrawer, updateOrderTable, removeOrderTable } from '@/store/actions';
import ToastMe from '@/components/ui/ToastMe';
import { Link } from 'react-router-dom';
import SidebarDrawer from '@/components/common/SidebarDrawer';

const POSSidebarCard = ({ addTableOrder, drawerBodyClassName }) => {
    const { tableOrder, tableSideDrawer } = useSelector((state) => state?.GeneralSetting);
    const dispatch = useDispatch();

    const handleDrawerClose = () => {
        dispatch(setTableSideDrawer(!tableSideDrawer));
        document.body.style.overflowY = 'auto';
    };

    const orderCreate = () => {
        if (tableOrder && tableOrder?.cartItems && tableOrder?.cartItems.length > 0) {
            addTableOrder();
            handleDrawerClose();
        } else {
            ToastMe('Please first add product in cart.', 'error');
            return true;
        }
    };

    const orderCancel = () => {
        dispatch(removeOrderTable());
        handleDrawerClose();
    };

    return (
        <SidebarDrawer icon="lab lab-add-circle-line" titleText={'My Cart'} activeDrawer={tableSideDrawer} handleDrawerClose={handleDrawerClose}>
            <div className="drawer-dialog">
                <div className={cn('drawer-body thin-scrolling overflow-y-auto', drawerBodyClassName)}>
                    <POSSidebarTable />
                </div>
                <div className="p-4">
                    <div className="flex items-center justify-between gap-2 rounded-xl p-3 mb-3 border border-gray-1">
                        <h3 className="capitalize text-sm font-medium">Subtotal</h3>
                        <h4 className="text-sm font-medium text-[#1AB759]">
                            <CurrencyCodeAdd price={tableOrder?.subtotal || 0} />
                        </h4>
                    </div>
                    <button type="button" onClick={orderCreate} className="rounded-3xl text-center capitalize text-[15px] py-3 px-3 w-full text-white bg-primary">
                        Proceed Checkout
                    </button>
                    <button type="button" onClick={orderCancel} className="mt-2 rounded-3xl text-center capitalize text-[15px] py-3 px-3 w-full text-white bg-[#FB4E4E]">
                        Clear Cart
                    </button>
                </div>
            </div>
        </SidebarDrawer>
    );
};

export default POSSidebarCard;
